import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { urlRegistroDesdeDemo } from '../../utils/demo';
import {
  EVENTO_ACCIONES,
  accionesHechas,
  capturaDescartada,
  descartaCaptura,
  esSesionDemo,
  marcaSesionDemo
} from '../../utils/demo';
import DemoLeadModal from './DemoLeadModal';

/**
 * Se cuentan ACCIONES, no minutos.
 *
 * Quien ya ha dado de alta un cliente, montado un servicio y emitido una
 * factura ha visto lo que hace GuideMe. Ese es el momento de ofrecerle hablar,
 * y no a los diez segundos de entrar, cuando todavía no sabe qué está mirando.
 */
const ACCIONES_PARA_INVITAR = 3;

export default function DemoCapture() {
  const { user, logout } = useAuth();
  const [acciones, setAcciones] = useState(accionesHechas);
  const [descartado, setDescartado] = useState(capturaDescartada);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    const alContar = (e: Event) => setAcciones((e as CustomEvent<number>).detail);
    window.addEventListener(EVENTO_ACCIONES, alContar);
    return () => window.removeEventListener(EVENTO_ACCIONES, alContar);
  }, []);

  const enDemo = Boolean((user as { isDemo?: boolean } | null)?.isDemo) || esSesionDemo();
  if (!enDemo) return null;
  if (descartado || acciones < ACCIONES_PARA_INVITAR) return null;

  const cerrar = () => {
    descartaCaptura();
    setDescartado(true);
  };

  const crearCuenta = () => {
    const destino = urlRegistroDesdeDemo();
    marcaSesionDemo(false);
    logout();
    window.location.href = destino;
  };

  return (
    <>
      {!modal && (
        <div className="fixed bottom-4 right-4 z-[90] w-[min(22rem,calc(100vw-2rem))] rounded-lg border border-gray-200 bg-white p-4 shadow-xl dark:border-gray-700 dark:bg-gray-800">
          <h3 className="mb-1 text-sm font-semibold text-gray-900 dark:text-white">
            ¿Lo hacemos con tus tours?
          </h3>
          <p className="mb-4 text-sm text-gray-600 dark:text-gray-400">
            Acabas de hacerlo con una guía de ejemplo. Con tu NIF y tu email lo
            tienes en tu cuenta en dos minutos. Gratis, sin tarjeta.
          </p>
          <button
            type="button"
            onClick={crearCuenta}
            className="mb-2 w-full rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Crear mi cuenta gratis
          </button>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={cerrar}
              className="flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              Sigo mirando
            </button>
            <button
              type="button"
              onClick={() => setModal(true)}
              className="flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              Prefiero que me llamen
            </button>
          </div>
        </div>
      )}

      <DemoLeadModal
        abierto={modal}
        onCerrar={() => {
          setModal(false);
          cerrar();
        }}
        origen="demo"
      />
    </>
  );
}
